import React from 'react'
import { connect } from 'react-redux'
import { t } from 'ttag'

import { getRespondent } from 'ducks/respondent'
import warningImg from 'assets/icons/warning.png'

import { DeadlineHint, MailHint } from '../Quiz/Quiz'
import { WaveContainer } from '../WaveContainer/WaveContainer'

import styles from './DeadlineExpired.module.scss'

export const DeadlineExpired = ({
  deadline,
  deadline_display,
  deadline_tz,
  language,
}) => {
  return (
    <WaveContainer>
      <div className={styles.centerContent}>
        <div className={styles.box}>
          <span className={styles.icon} aria-hidden>
            <img alt="warning" src={warningImg} />
          </span>
          <div className={styles.text}>
            <p className={styles.paragraph}>
              {t`Unfortunately, the deadline for completing the tests has expired, and you no longer have access to them.`}
            </p>
            <p className={styles.paragraph}>
              {t`If you would still like to complete the tests, please contact the recruitment manager at the company.`}
            </p>
          </div>
        </div>
      </div>

      <div className={styles.hints}>
        <DeadlineHint
          {...{ deadline, deadline_display, deadline_tz, language }}
          past_deadline
        />
        <MailHint />
      </div>
    </WaveContainer>
  )
}

export default connect(getRespondent)(DeadlineExpired)
